@for (suggestion of suggestions; track suggestion) {
	<div class="badge">
		<mat-icon svgIcon="smart-suggest"></mat-icon>
		<p>{{ suggestion.name }}</p>
		<mat-icon
			class="accuracy"
			svgIcon="{{ 'accuracy-' + suggestion.confidenceLevel | lowercase }}"
		/>
		<div class="hover-buttons">
			<button mat-icon-button class="btn" (click)="acceptSuggestion(suggestion)">
				<mat-icon class="icon-checkmark">done</mat-icon>
			</button>
			<button mat-icon-button class="btn" (click)="rejectSuggestion(suggestion)">
				<mat-icon class="icon-checkmark red">close</mat-icon>
			</button>
		</div>
	</div>
}
